import React from "react";
import UserIcon from "../../../../../icons/UserIcon";
import { DateTime } from "luxon";
interface BidHistoryCardProps {
  typeOfBid: "user" | "others";
  bidsTagText?: string;
  bidsPrice: string | number;
  bidTimestamp: string | number;
  showStatus: boolean;
  bidsStatusText?: "Success" | "Failed";
  userName?: string;
  app?: "bidder" | "banker" | "others" | false;
  bidData?: any;
  index?: number;
  isSwissAuction: boolean;
}
export default function BidHistoryCard({
  bidsTagText = "New bid placed",
  bidsPrice,
  showStatus,
  bidsStatusText = "Success",
  bidTimestamp,
  typeOfBid,
  userName,
  bidData,
  app,
  index,
  isSwissAuction = false,
}: BidHistoryCardProps) {
  return (
    <div className="flex justify-between items-center text-[10px] md:text-xs border-b-[1px] py-2">
      <div className="flex items-center">
        {typeOfBid === "others" && (
          <div className="bg-[#F1EAFF] rounded-full p-[2px]">
            <UserIcon width={22} height={22} />
          </div>
        )}
        {typeOfBid === "user" && (
          <div className="bg-[#FEECE6] rounded-full px-[10px] py-[6px] text-[#C95619] capitalize text-xs">
            {/* <UserIcon width={22} height={22} /> */}
            <div>{userName?.charAt(0)}</div>
          </div>
        )}
        <div className="pl-3">
          <div
            className={` lg:leading-6 ${
              app === "banker" && bidsStatusText === "Success"
                ? "text-[#4DBB3E]"
                : app === "banker" && bidsStatusText === "Failed"
                ? "text-[#B60100]"
                : bidsStatusText === "Success" &&
                  typeOfBid === "user" &&
                  index === 0
                ? "text-[#4DBB3E]"
                : bidsStatusText === "Failed"
                ? "text-[#B60100]"
                : "text-brand-bgBlack"
            }`}
          >
            {typeOfBid === "user"
              ? bidsStatusText === "Success"
                ? "Your bid has placed successfully"
                : "Your bid has failed"
              : app === "banker" && bidsStatusText === "Success"
              ? "New bid placed"
              : app === "banker" && bidsStatusText === "Failed"
              ? "Failed bid"
              : bidsStatusText === "Success"
              ? "New bid placed"
              : "Failed bid"}
          </div>
          <div className="mt-[2px]">{`${
            bidsPrice ? `₹ ${bidsPrice}` : "Na"
          }`}</div>
          {/* Banker Dashboard */}
          {/* {app === "banker" && (
            <div>
              <div className={`${bidData?.meta?.user_ip ? "" : "hidden"}`}>
                IP Address:
                <span>{` ${bidData?.meta?.user_ip}`}</span>
              </div>
              <div className={`${bidsStatusText === "Failed" ? "" : "hidden"}`}>
                Reason:
                <span>{` ${bidData?.reason}`}</span>
              </div>
            </div>
          )} */}
        </div>
      </div>
      <div className="text-xs gap-1 sm:gap-0 items-center text-gray-400">
        <p className="text-right">
          {" "}
          {bidData?.meta?.initial_bid
            ? isSwissAuction
              ? `Anchor bid`
              : `Offer value`
            : `${DateTime.fromMillis(
                typeof bidTimestamp === "string"
                  ? parseInt(bidTimestamp)
                  : bidTimestamp,
              )
                .setZone("Asia/Kolkata")
                .toFormat("hh:mm:ss a")} (IST)`}
        </p>
        {showStatus && (
          <span
            className={`ml-4 px-4 py-[2px] rounded-full capitalize text-[10px] ${
              bidsStatusText === "Success" ? "bg-[#F2FFEA]" : "bg-[#FFF3F3]"
            } tracking-wider`}
          >
            {bidsStatusText}
          </span>
        )}
        <div
          className={`${
            bidsStatusText === "Failed" ? "" : "hidden"
          } w-[100px] sm:w-fit `}
        >
          <span>{` ${bidData?.reason}`}</span>
        </div>
      </div>
    </div>
  );
}
